import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChamadoEmpresaRoutingModule } from './chamado-empresa-routing.module';


@NgModule({
    imports: [
        CommonModule,
        ChamadoEmpresaRoutingModule,
    ]
})
export class ChamadoEmpresaModule { }
